<template>
  <div
    class="overflow-hidden"
    :style="{height: height === 'auto' ? 'auto' : (height + 'px')}"
  >
    <div
      ref="inner"
      v-resize:throttle="onResize"
    >
      <div :style="previewStyles">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Width Aware Container
 * will shrink the contents of this div to match the size of the parent container while
 * maintaining the aspect ratio
 *
 * SLOTS:
 * - default: content to display
 */
import resize from 'vue3-resize-directive'

export default {
  directives: {
    resize
  },
  props: {
    // The width to persist
    width: {
      type: Number,
      required: true
    },
    // Center the contents in the div horizontally
    center: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      scale: 1,
      height: 'auto'
    }
  },
  computed: {
    previewStyles () {
      return {
        'transform': 'scale(' + this.scale + ') translateZ(0)',
        'width': this.width + 'px',
        'transform-origin': 'top left',
        'margin': this.center ? '0 auto' : '0'
      }
    }
  },
  methods: {
    onResize (e) {
      const scale = (e.offsetWidth) / this.width
      this.scale = scale < 1 ? scale : 1
      this.height = Math.ceil(this.$refs.inner.clientHeight * this.scale)
    }
  }
}
</script>
